import {Component, OnInit} from '@angular/core';
import { ModalExtended} from 'ngx-dynamic-modal';
import { Pricing} from '../../model/pricing';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { DatesParserService} from '../../../../../core/service/dates_parser.service';
import {PricingService} from '../../services/pricing.service';
import {AuthService} from '../../../../../core/service/auth.service';
import { AuxiliarService} from '../../../../../shared/services/auxiliar.service';
import { AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-edit-pricing-modal',
  templateUrl: './edit-pricing-modal.component.html',
  styleUrls: ['./edit-pricing-modal.component.scss']
})

export class EditPricingModalComponent extends ModalExtended implements OnInit{

    data: any;
    enabled:boolean;
    pricing = new Pricing();
    formSearch: FormGroup;
    fromHr:any;
    priceAsObj:boolean=false;
    portal_pk:any;
    isValidObj:boolean;

    constructor(private fb: FormBuilder,
                private date: DatesParserService,
                private  pricingService: PricingService,
                private  auth:AuthService,
                private  aux:AuxiliarService,
                private alerta:AlertaService) {
        super();
        let from= new Date();
        from.setHours(0,0,0,0);
        this.fromHr=from;
        this.portal_pk=this.auth.getPkPortal();

        this.formSearch = new FormGroup(
            {
                'service_pk':new FormControl(null,Validators.required),
                'currency_pk':new FormControl(null,Validators.required),
                'start_date':new FormControl(null,Validators.required),
                'service_provider_pk':new FormControl(null,Validators.required),
                'comments':new FormControl(null),
                'price_data':new FormControl(null,Validators.required),
            }
        );
    }

    ngOnInit() {
        if (this.data.element) {
            this.enabled = true;
            this.pricing = this.data.element;
            this.priceAsObj=this.aux.isObj(this.pricing.price_data);

            if(this.priceAsObj){
                this.isValidObj = true;
            }

            this.formSearch.controls['service_pk'].setValue(this.pricing.service_pk);
            this.formSearch.controls['currency_pk'].setValue(this.pricing.currency_pk);
            this.formSearch.controls['start_date'].setValue(this.pricing.start_date);
            this.formSearch.controls['service_provider_pk'].setValue(this.pricing.service_provider_pk);
            this.formSearch.controls['comments'].setValue(this.pricing.comments);
            this.formSearch.controls['price_data'].setValue(this.pricing.price_data);
            this.enabled = false;
        }
    }

    onExit(data=null) {
        this.applyCallback(data);
        this.close();
    }

    checkForm(){
        if(this.priceAsObj){
            if(this.isValidObj){
                return true;
            }else{
                return false;}
            }
        return true;
    }

    savePricing(form) {
        if (form.valid && this.checkForm()) {
            this.enabled = true;
            let pricing = this.date.cleanDates(this.formSearch.value, ['start_date'], false);
            pricing['portal_pk'] = this.portal_pk;
            this.pricingService.postPricingHistory(pricing)
                    .subscribe(result => {
                        this.onExit({edit: false, data: result.data});
                    }, error => {
                        console.log(error)
                    }, () => {
                       this.alerta.addAlert('success','Pricing Created Succesfully!!');
                        this.enabled = false;
                    })
        }
    }

    updatePricing(form){
        if (form.valid && this.checkForm()) {
            this.enabled = true;
            let pricing = this.date.cleanDates(this.formSearch.value, ['start_date'], false);
            pricing['portal_pk'] = this.portal_pk;
            pricing['pk'] = this.pricing.pk;
            this.pricingService.putPricingHistory(pricing)
                .subscribe(result => {
                    console.log(result)
                    this.onExit({edit: true, data: result.data});
                }, error => {
                    console.log(error);
                }, () => {
                    this.alerta.addAlert('success', 'Pricing Updated Succesfully!!');
                    this.enabled = false;
                })
        }

    }

    check() {
        if (this.formSearch.value.price_data != null) {
            this.alerta.addAlert('confirm', 'If you change the type of price,the old data will reset')
                .then((result) => {
                    if (result.value) {
                        this.formSearch.controls.price_data.setValue(null);
                    } else {
                        this.priceAsObj=(this.priceAsObj)?false:true;
                    }
                })
        }
    }

}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/pricing/modals/edit-pricing-modal/edit-pricing-modal.component.ts